// extracted by mini-css-extract-plugin
module.exports = {"plan_wire_class":"FJMultiProcessContainer_plan_wire_class__31N_L","process_line_class":"FJMultiProcessContainer_process_line_class__3Sxxw"};